import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { PageCreatePage } from '@/features/pages';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/pages/new')({
  staticData: { crumb: 'pages:new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.write');
  },
  component: PageCreatePage,
});
